// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
import router from './router'
import store from './store'
import Storage from 'vue-ls'
import 'vue2-admin-lte/src/lib/css'
import 'vue2-admin-lte/src/lib/script'
import SessionService from './utils/SessionService'
import webservice from './utils/webservice'

import VueHtml5Editor from 'vue-html5-editor'
import VueHtml5EditorOptions from './utils/wysiwyg_options'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css' // Ensure you are using css-loader
import infiniteScroll from 'vue-infinite-scroll'

import VueApexCharts from 'vue-apexcharts'

Vue.component('apexchart', VueApexCharts)

Vue.use(infiniteScroll)

Vue.use(VueHtml5Editor, VueHtml5EditorOptions)

Vue.use(Vuetify, {
  theme: {
    primary: '#1976D2',
    secondary: '#424242',
    accent: '#82B1FF',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107'
  }
})
// import 'bootstrap/dist/css/bootstrap-reboot.min.css'
// import 'bootstrap/dist/css/bootstrap.min.css'
// import 'bootstrap/dist/css/bootstrap-grid.min.css'

let optionsStorage = {
  namespace: 'vuejs__', // key prefix
  name: 'ls', // name variable Vue.[ls] or this.[$ls],
  storage: 'local' // storage name session, local, memory
}

Vue.use(Storage, optionsStorage)
Vue.use(Vuex)

Vue.config.productionTip = false

/* eslint-disable no-new */
// noinspection JSUnusedGlobalSymbols
window.vm = new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<v-app><App/></v-app>',
  beforeMount () {
    let jwtToken = Vue.ls.get('token')
    if (jwtToken !== null) {
      webservice.jwtToken = jwtToken
      this.$store.commit('app/setToken', jwtToken)
      this.$store.commit('app/setUsername', SessionService.getUsername(jwtToken))
      this.$store.commit('app/setRoles', SessionService.getRoles(jwtToken))
      this.$store.commit('app/setPayload', SessionService.getPayload(jwtToken))
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js